// parceiros-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Aceita cashback?": "¿Acepta cashback?",
    "Banco": "Banco",
    "CNPJ": "CNPJ",
    "Cadastrar novo parceiro": "Registrar nuevo socio comercial",
    "Credenciais": "Credenciales",
    "Desconto negociado (Cashback)": "Descuento negociado (Cashback)",
    "Desconto negociado (Produtos)": "Descuento negociado (Productos)",
    "Editar novo parceiro": "Editar nuevo socio comercial",
    "GPS": "GPS",
    "Host ou ip": "Host o ip",
    "Imagem Atual": "Imagen actual",
    "Integração": "Integración",
    "Latitude": "Latitud",
    "Limite de dias para resgate de cupom": "Límite de días para canje de cupón",
    "Longitude": "Longitud",
    "Numero": "Número",
    "Porta": "Puerto",
    "Possui comanda eletrônica?": "¿Posee comanda electrónica?",
    "Rua": "Calle",
    "ra.action.clear_input": "ra.action.clear_input",
};

export default catalogo;
